module.exports = __webpack_public_path__ + "static/media/disputeTransfers1.c270ed10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/disputeTransfers1.svg
// module id = 1650
// module chunks = 2